<template>

    <m-edit1/>

    <m-products-3 v-bind='{...{"perPage":12,"productCardName":"mProductCard912","cardCLass":"my-1","cardWrapperCLass":"col-lg-4 archive-parent-item","showCategoriesSlider":false,"offerType":"number","offerStatus":true,"productBrandProp":false,"productSearchProp":true,"productQuantityProp":false,"productFeatureProp":true,"productFeaturePanelOpenCloseProp":false,"productCategoryProp":true,"productStoresProp":false,"productSortProp":false,"relatedCurrentCategory":true,"productPriceFilterProp":true,"showKeywords":false,"smCardName":"mProductCard912","skeleton":"mProductArchiveSkeleton1","dashboardProduct":false,"publishStatusFilter":false,"image":null,"alt":"mix it web","cardLink":true,"infinityLoading":false,"chooseCategoriesFromTop":false,"cardLinkTarget":"_self","productStoresDirectFilter":null,"orderFilterProp":["brand","feature","category","search","quantity","store","price"],"archiveFilterProp":false},...{}}' :style='""' class="my-5" ></m-products-3>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mProducts3 from '@moeinmdn/miw-alpha-components/src/package/Product/Products/Products3/Products3';

export default {
    name: 'HomeView',
    components: {mEdit1, mProducts3 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
